import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as JobsStore from '../../store/jobs';
import { JobRequestContractor } from '../../components/jobs/JobRequestContractor';
import { isJobHasContractorPropertyGroupType } from '../../models';

export default connect(
    (state: ApplicationState) => ({
        activityTypes: state.user.activityTypes,
        constants: state.constants,
        propertyGroupTypes: state.user.propertyGroupTypes.filter(isJobHasContractorPropertyGroupType),
        legalForms: state.user.legalForms,
        ...JobsStore.plainActions,
    }),
    JobsStore.actionCreators,
)(JobRequestContractor as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
